export const addFilterTextHeadingJobResults = ():void => {

    const filterHeading = document.querySelector<HTMLElement>("#filter-header");

    if (!filterHeading) return;

        filterHeading.innerHTML =
            "<h4>{{js.job-results-filter-heading}}</h4>";
};

export const moveKeyword = ():void => {
    const keyword = document.querySelector<HTMLElement>("#keyword-option-wrapper");
    const container = document.querySelector<HTMLElement>(".page-job-results__hero-inner .col-md-12");
    if (!keyword || !container) return;

   
    container.append(keyword);

    keyword.style.display = "flex";
};